import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { fetchWaitlistCountsThunk, openWaitlistPanel } from 'actions/waitlists/WaitlistsActions';
import Button from 'components/UI/V3/Button/Button';
import { getWaitlistCount } from 'components/Waitlist/waitlistUtils';
import { WaitlistCounts, WaitlistKey } from 'model/Waitlist';
import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface WaitlistButtonProps {
    waitlistKey: WaitlistKey;
    marketplaceIds: Array<number>;
    className?: string;
}

export const WaitlistButton: FunctionComponent<WaitlistButtonProps> = ({ waitlistKey, marketplaceIds, className }) => {
    const dispatch = useDispatch();

    const counts = useSelector<RootState, WaitlistCounts | undefined>(state => state.waitlists.counts);

    const marketplaceIdsKey = marketplaceIds.join(',');

    useEffect(() => {
        dispatch(fetchWaitlistCountsThunk(marketplaceIds));
    }, [marketplaceIdsKey]);

    const count = getWaitlistCount(counts, waitlistKey);

    return (
        <Button
            variant="outlined"
            size="large"
            leftIcon={faClockRotateLeft}
            label={count === undefined ? 'Waitlist' : `Waitlist (${count})`}
            className={className}
            onClick={() => dispatch(openWaitlistPanel(waitlistKey, marketplaceIds))}
        />
    );
};

export default WaitlistButton;
